/**
 * Weight Progress Chart Module
 *
 * Initializes Chart.js weight progress visualization
 */

export const initWeightChart = () => {
	const chartElement = document.getElementById('weightProgressChart');

	if (!chartElement || typeof Chart === 'undefined') return;

	// Get data from data attributes
	const dateLabels = JSON.parse(chartElement.dataset.labels || '[]');
	const weightData = JSON.parse(chartElement.dataset.weights || '[]');
	const statuses = JSON.parse(chartElement.dataset.statuses || '[]');
	const maxWeight = parseFloat(chartElement.dataset.max || 0);


	// Status color mapping
	const statusColors = {
		'Locked': '#CFD1D3',      // Gray - not started
		'In Progress': '#ECB95D', // Blue - current
		'Done': '#17B26A'         // Green - completed
	};

	// Generate color array for each point based on status
	const pointColorsActual = statuses.map(status => statusColors[status] || '#3B82F6');
	const pointColorsTarget = statuses.map(status => status === 'In Progress' ? '#ECB95D' : '#CFD1D3');
	const actualWeights = weightData.map(item => item.actual).filter(item => item > 0);
	const targetWeights = weightData.map(item => item.target).filter(item => item > 0);

	if (actualWeights.length === 0 && targetWeights.length === 0) return;

	// eslint-disable-next-line no-undef
	new Chart(chartElement, {
		type: 'line',
		data: {
			labels: dateLabels,
			datasets: [
				{
					label: wpcore.direct_t({ en: 'Actual weight', fr: 'Poids actuel' }),
					data: actualWeights,
					borderColor: '#CFD1D3',
					backgroundColor: 'rgba(59, 130, 246, 0.1)',
					borderDash: [5, 5],
					tension: 0.4,
					fill: false,
					pointRadius: 6,
					pointHoverRadius: 8,
					pointBackgroundColor: pointColorsActual,
					pointBorderColor: pointColorsActual,
					pointBorderWidth: 2,
					borderWidth: 3
				},
				{
					label: wpcore.direct_t({ en: 'Target weight', fr: 'Poids cible' }),
					data: targetWeights,
					borderColor: '#CFD1D3',
					backgroundColor: 'rgba(59, 130, 246, 0.1)',
					borderDash: [5, 5],
					tension: 0.4,
					fill: false,
					pointRadius: 6,
					pointBackgroundColor: pointColorsTarget,
					pointBorderColor: pointColorsTarget,
					pointHoverRadius: 8,
					pointBorderWidth: 2,
					borderWidth: 3
				}
			]
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			interaction: {
				mode: 'index',
				intersect: false,
			},
			plugins: {
				legend: {
					display: false
				},
				tooltip: {
					backgroundColor: 'rgba(0, 0, 0, 0.8)',
					padding: 12,
					cornerRadius: 8,
					titleFont: {
						family: 'Montserrat',
						size: 14,
						weight: 'bold'
					},
					bodyFont: {
						family: 'Montserrat',
						size: 13
					},
					callbacks: {
						label: function (context) {
							const weight = context.parsed.y;
							return `${context.dataset.label}: ${weight || 'N/A'}`;
						},
					}
				}
			},
			scales: {
				y: {
					min: Math.min(...actualWeights, ...targetWeights),
					max: maxWeight,
					grid: {
						color: '#EAEBEC',
						lineWidth: 2,
						drawBorder: false,
					},
					ticks: {
						maxTicksLimit: 6,
						callback: function (value) {
							return value;
						},
						font: {
							family: 'Montserrat',
							size: 11
						},
						color: '#57595C'
					}
				},
				x: {
					offset: false,
					grid: {
						display: true,
						color: '#EAEBEC',
						lineWidth: 2,
						drawBorder: false
					},
					ticks: {
						font: {
							family: 'Montserrat',
							size: 11
						},
						color: '#57595C',
						maxRotation: 0,
						autoSkip: false
					}
				}
			}
		}
	});
};
